// DO NOT EDIT THIS FILE. It should be automatically generated by running
// pnpm generate-product-schemas
import { format } from 'date-fns/format'
import * as z from 'zod'

import * as constants from '@nxt-insurance/constants'

// This is the base schema that can be extended when using it in configs
export const BaseSchema_PetHealthV2GetsafeDe = z.object({
  chipped: z.boolean().optional(),
  species: z.enum(['dog', 'cat']),
  neutered: z.boolean().optional(),
  pet_name: z.string().min(1).optional(),
  zip_code: z
    .string()
    .min(1)
    .regex(/^(?!01000|99999)(0[1-9]\d{3}|[1-9]\d{4})$/),
  breed_type: z.enum(['crossbreed', 'pedigree']),
  pet_gender: z.enum(['female', 'male']).optional(),
  chip_number: z.string().optional(),
  pet_born_on: z
    .union([z.number(), z.string(), z.date()])
    .pipe(z.coerce.date())
    .transform((value) => {
      return format(value, constants.SERVER_DATE_FORMAT)
    }),
  sum_insured: z.enum(['3000', '5000', '7500', 'unlimited']),
  tariff_type: z.enum(['full_coverage', 'surgery_coverage']),
  addon_dental: z.boolean(),
  addon_sos_budget: z.boolean(),
  first_breed_name: z.string().min(1),
  second_breed_name: z.string().min(1).optional(),
  previous_insurance: z.enum(['unknown', 'true', 'false']).optional(),
  addon_preventive_care: z.boolean(),
  current_health_status: z.enum(['healthy', 'recent_complaints', 'current_complaints']).optional(),
  deductible_percentage: z.coerce
    .string()
    .pipe(z.enum(['0', '10', '20']))
    .pipe(z.coerce.number()),
  health_status_entries: z
    .array(
      z.object({
        health_status_area: z
          .enum([
            'respiratory_organs',
            'eyes',
            'musculoskeletal_system',
            'male_genital_organs',
            'female_genital_organs',
            'urinary_organs',
            'skin',
            'cardiovascular_organs',
            'endocrine_glands',
            'immune_system',
            'liver',
            'oral_cavity',
            'nervous_system',
            'ears',
            'systemic',
            'digestive_organs',
            'other',
            'unknown',
          ])
          .optional(),
        health_status_diagnosis: z.string().optional(),
      })
    )
    .optional(),
  shoulder_height_class: z.enum(['lt_45_cm', 'gte_45_cm']).optional(),
  previous_insurance_end_on: z
    .union([z.number(), z.string(), z.date()])
    .pipe(z.coerce.date())
    .nullish()
    .transform((value) => {
      if (value === undefined || value === null) {
        return value
      }
      return format(value, constants.SERVER_DATE_FORMAT)
    })
    .optional(),
  health_status_acknowledged_on: z
    .union([z.number(), z.string(), z.date()])
    .pipe(z.coerce.date())
    .transform((value) => {
      return format(value, constants.SERVER_DATE_FORMAT)
    })
    .optional(),
})

const Schema_PetHealthV2GetsafeDe = BaseSchema_PetHealthV2GetsafeDe.superRefine((values, ctx) => {
  if (values['breed_type'] !== undefined && ['crossbreed'].includes(values['breed_type'])) {
    if (values['second_breed_name'] === undefined) {
      ctx.addIssue({
        code: z.ZodIssueCode.invalid_type,
        expected: 'string',
        received: 'undefined',
        message: 'Required',
        path: ['second_breed_name'],
      })
    }
  }
})
  .superRefine((values, ctx) => {
    if (
      values['current_health_status'] !== undefined &&
      ['recent_complaints', 'current_complaints'].includes(values['current_health_status'])
    ) {
      if (values['health_status_entries'] === undefined) {
        ctx.addIssue({
          code: z.ZodIssueCode.invalid_type,
          expected: 'array',
          received: 'undefined',
          message: 'Required',
          path: ['health_status_entries'],
        })
      }
    }
  })
  .superRefine((values, ctx) => {
    if (
      values['species'] !== undefined &&
      ['dog'].includes(values['species']) &&
      values['first_breed_name'] !== undefined &&
      ['unknown'].includes(values['first_breed_name']) &&
      values['second_breed_name'] !== undefined &&
      ['unknown'].includes(values['second_breed_name'])
    ) {
      if (values['shoulder_height_class'] === undefined) {
        ctx.addIssue({
          code: z.ZodIssueCode.invalid_type,
          expected: 'string',
          received: 'undefined',
          message: 'Required',
          path: ['shoulder_height_class'],
        })
      }
    }
  })
  .superRefine((values, ctx) => {
    if (
      values['previous_insurance'] !== undefined &&
      ['true'].includes(values['previous_insurance'])
    ) {
      if (values['previous_insurance_end_on'] === undefined) {
        ctx.addIssue({
          code: z.ZodIssueCode.invalid_type,
          expected: 'date',
          received: 'undefined',
          message: 'Required',
          path: ['previous_insurance_end_on'],
        })
      }
    }
  })
  .superRefine((values, ctx) => {
    if (
      values['current_health_status'] !== undefined &&
      ['recent_complaints', 'current_complaints'].includes(values['current_health_status'])
    ) {
      if (values['health_status_acknowledged_on'] === undefined) {
        ctx.addIssue({
          code: z.ZodIssueCode.invalid_type,
          expected: 'date',
          received: 'undefined',
          message: 'Required',
          path: ['health_status_acknowledged_on'],
        })
      }
    }
  })

export default Schema_PetHealthV2GetsafeDe
